import { Box, BoxProps, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { TitleOfBlock, useRadioControlStyles } from '@uplift/ui-v2';
import { useField } from 'formik';
import { ClinicalNotesFormType, ClinicalNotesTemplateType } from '../types';

export type ClinicalNotesHeaderProps = BoxProps;

const templateOptions: { label: string; value: ClinicalNotesTemplateType }[] = [
  { label: 'Initial', value: 'initial' },
  { label: 'Follow-up', value: 'followUp' },
];

export const ClinicalNotesHeader: React.VFC<ClinicalNotesHeaderProps> = ({ ...boxProps }) => {
  const l10n = useL10n();
  const [ field ] = useField<ClinicalNotesFormType['template']>('template');
  const { classes } = useStyles();
  const { classes: radioClasses } = useRadioControlStyles();

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap="1rem" {...boxProps}>

      <TitleOfBlock text={l10n.clinicalNotes.progressNote} className={classes.title} />

      <Box display="flex" alignItems="center" gap="1.5rem">
        <FormLabel className={classes.templateLabel}>{l10n.clinicalNotes.selectTemplate}</FormLabel>
        <RadioGroup name="template" row {...field}>
          {templateOptions.map(({ value, label }) => (
            <FormControlLabel
              key={value}
              value={value}
              label={label}
              className={classes.radioControl}
              control={<Radio size="small" color="secondary" className={radioClasses.radioRoot} />}
            />
          ))}
        </RadioGroup>
      </Box>

    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  title: {
    margin: 0,
  },
  templateLabel: {
    marginTop: theme.spacing(.25),
  },
  radioControl: {
    margin: 0,
    '&:not(:first-of-type)': {
      marginLeft: theme.spacing(2)
    }
  },
}));
